// Company product modules (backend FeatureModuleCatalog codes). A platform admin
// switches them on or off per company; the login carries the list as enabledModules.
// Kept free of the store so the rule can be unit-tested.

export type FeatureModuleCode =
  | 'jobs' | 'customers' | 'attendance' | 'holidays' | 'clothing' | 'fleet'
  | 'machines' | 'audit' | 'reports' | 'training' | 'communications';

// An unknown list (a session from before the field existed) counts as every module
// on: hiding UI on a guess would be wrong, and the server enforces anyway.
export const isModuleEnabledIn = (enabledModules: unknown, code: FeatureModuleCode): boolean =>
  !Array.isArray(enabledModules) || enabledModules.includes(code);
